import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfy5cq4nlt: FaireProductEntity = {
  token: "p_nfy5cq4nlt",
  type: "product",
  name: "I'm A Hug Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3cc3bb1615a78ab902ef1c117f13fba2cf77873c4de3af4966c3c22053962f00.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a93b33f1a4df22dfb20b3b7303d730d61283798606e229e9cf8af5be94207f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:20.488Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
